import StudentdashboardModule from './containers/studentdashboardModule'

export {default as StudentdashboardModuleLayout} from './components/studentdashboardModuleLayout'

export default StudentdashboardModule
